'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetIsInAwayMode = undefined;

var _reselect = require('reselect');

var _getAvailabilityAwayMessage = require('./getAvailabilityAwayMessage');

var widgetIsInAwayMode = exports.widgetIsInAwayMode = (0, _reselect.createSelector)([_getAvailabilityAwayMessage.getAvailabilityAwayMessage], function (awayMessage) {
  return Boolean(awayMessage);
});


//////////////////
// WEBPACK FOOTER
// ./js/availability/selectors/widgetIsInAwayMode.js
// module id = 135
// module chunks = 2 3